import { apiLeaveRequests } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'leave-requests';

const config = [
  { actionType: 'getAll', apiPath: apiLeaveRequests, method: get, actionParams: { limit: 0 } },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiLeaveRequests}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
